function HeaderFinal() {
  const button = document.querySelector('.header-final__button-mobile');
  const header = document.querySelector('.header-final');
  const headerMobile = document.querySelector('.header-final__left');
  const trigger = document.querySelector('.header-trigger');
  const alertText = document.querySelector('aside.alert-text');
  const body = document.body;

  //Margin for fixed header
  if(header && headerMobile) {
    const resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
          const desktopMargin = header.offsetHeight;
          const mobileMargin = header.offsetHeight;
          const margin = window.matchMedia('(max-width: 1390px)').matches ? mobileMargin : desktopMargin;
          body.style.setProperty('--margin-top', `${margin}px`);

          const alertTextHeight = alertText ? alertText.offsetHeight : 0;
          body.style.setProperty('--alert-text-height', `${alertTextHeight}px`);
      });
    });

    resizeObserver.observe(header);
  }
  
  //Toggle Mobile
  if(button && header) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      header.classList.toggle('open');
    });
  }

  //Change Scroll Position
  if (trigger && header) {
    const observerOptions = {
      rootMargin: '0px',
      threshold: 0
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          header.classList.add('alt-view');
        }
        else {
          header.classList.remove('alt-view');
        }
      });
    }, observerOptions);

    observer.observe(trigger);
  }

  //Detect dropdowns
  if(header) {
    const links = header.querySelectorAll('nav > .menu > li > a');
    const dropDowns = header.querySelectorAll('.dropdown-wrapper');
    const subDropDowns = header.querySelectorAll('.accordion-trigger');
    const subDropDownClosers = header.querySelectorAll('.dropdown-close-trigger');

    function closeAllDropDowns(current) {
      if (dropDowns) {
        dropDowns.forEach(dropDown => {
          if (current !== dropDown) {
            dropDown.previousElementSibling.classList.remove('active');
          }
        });
      }
    }

    function closeAllSubDropDowns(current) {
      if (subDropDowns) {
        subDropDowns.forEach(subDropDown => {
          if (current !== subDropDown) {
            subDropDown.classList.remove('active');
          }
        });
      }
    }

    function outSideClick(element) {
      if (!header.contains(element) && !element.classList.contains('has-dropdown')) {
        closeAllDropDowns();
        body.classList.remove('menu-is-open');
      }
    }

    if (links) {
      links.forEach(link => {
        if (link.nextElementSibling && link.nextElementSibling.classList.contains('dropdown-wrapper')) {
          link.classList.add('has-dropdown');
          link.addEventListener('click', function(e) {
            e.preventDefault();
            closeAllDropDowns(link.nextElementSibling);
            link.classList.toggle('active');
            body.classList.toggle('menu-is-open');
          });
        }
      });
    }

    if(subDropDowns) {
      subDropDowns.forEach(subDropDown => {
        subDropDown.addEventListener('click', function() {
          //closeAllSubDropDowns(subDropDown);
          //subDropDown.classList.toggle('active');
        });
      });
    }

    if(subDropDownClosers) {
      subDropDownClosers.forEach(subDropDownCloser => {
        subDropDownCloser.addEventListener('click', function(e) {
          e.preventDefault();
          subDropDownCloser.closest('.dropdown-wrapper').previousElementSibling.classList.remove('active');
        });
      });
    }

    body.addEventListener('click', function(e) {
      outSideClick(e.target);
    });
  }
}

export default HeaderFinal;